export enum NotificationMetric {
  CallIn = 'Calls In',
  CallOut = 'Calls Out',
  SpokeToCandidate = 'Spoke w/ Candidate',
  CandidateContacted = 'Candidate Contacted',
  EmailSent = 'Emails Sent',
  OpenRate = 'Open Rate',
  MessageIn = 'Texts Received',
  MessageOut = 'Texts Sent',
}

export interface IKPITileProps {
  primaryLabel: string;
  secondaryLabel?: string;
  placeholder?: string;
  value: number | string;
  showProgress?: boolean;
  disabled?: boolean;
  onClickHandler: (label) => void;
  selectedMetric: string;
}
